import { Component } from '@angular/core';

interface QuickFact {
  title: string;
  description: string;
}

@Component({
  selector: 'sbnb-signup-quick-facts',
  templateUrl: './signup-quick-facts.component.html',
})
export class SignupQuickFactsComponent {
  quickFacts: QuickFact[] = [
    {
      title: '25',
      description: 'Hours saved on average for hosts per month',
    },
    {
      title: '$178',
      description: 'More revenue per booking with Direct Premium',
    },
    {
      title: '14',
      description: 'Day free trial of our Professional plan',
    },
    {
      title: '90%',
      description: 'Of hosts messages automated from Day 1',
    },
  ];
}
